import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useApi from "../../../core/customhook/useApi";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import Swal from "sweetalert2";
import { employee_email } from "../../../environment";
import {
  getFinancialYearList,
  getFinancialYearListNew,
} from "../../../core/common/financialYear";

const R1ManagerAllEmployee = () => {
  const employee_id = useParams();

  const [finance_year, setFinance_year] = useState("");

  const {
    data: finYearData,
    loading: finYearLoading,
    error: finYearError,
  } = useApi("/api/get-apprisal-fin-year", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (finYearData?.data?.fin_year) {
      setFinance_year(finYearData.data.fin_year);
    }
  }, [finYearData]);

  const { data: skipmanagerEmployee, loading: ManagerLoading } = useApi(
    "/api/get-r2-manager-employee",
    {
      method: "POST",
      payload: {
        financial_year: finance_year,
      },
      autoCall: true,
      dependencies: [finance_year],
    },
  );

  const data = skipmanagerEmployee?.data.map((item: any, index: any) => {
    return {
      ...item,
      Sno: index + 1,
    };
  });
  

  const getStatusBadge = (status: string | null) => {
    let color = "";
    let label = status;

    switch (status) {
      case null:
      case "Pending":
        color = "bg-secondary";
        label = "Pending"; // make null display as Pending
        break;
      case "InProgress":
        color = "bg-warning";
        break;
      case "proced 1 on 1":
        color = "bg-warning";
        label = "Proceed 1 on 1";
        break;
      case "Draft":
        color = "bg-warning";
        break;
       case "Save As Draft Skip Manager":
        color = "bg-warning";
        break;  
      case "Revert to manager":
        color = "bg-warning";
        break;
      case "Submit":
        color = "bg-success";
        label = "Submitted";
        break;
      default:
        color = "bg-secondary";
        label = "Pending";
    }

    return <span className={`badge ${color}`}>{label}</span>;
  };

  const columns = [
    { title: "SNo.", dataIndex: "Sno" },
    {
      title: "Employee Id",
      dataIndex: "employee_id",
      render: (text: string) => <p>{text}</p>,
      sorter: (a: any, b: any) => a.employee_id.localeCompare(b.employee_id),
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      render: (text: string) => <p>{text}</p>,
      sorter: (a: any, b: any) =>
        a.employee_name.localeCompare(b.employee_name),
    },
    {
      title: "Designation",
      dataIndex: "designation",
    },
    {
      title: "Department",
      dataIndex: "department",
    },
    {
      title: "Employee Status",
      dataIndex: "status",
      render: (text: string | null) => getStatusBadge(text),
    },
    {
      title: "Manager Status",
      dataIndex: "manager_status",
      render: (text: string | null) => getStatusBadge(text),
    },
    {
      title: "Skip Manager Status",
      dataIndex: "skip_manager_status",
      render: (text: string | null) => getStatusBadge(text),
    },
    {
      title: "Action",
      render: (_: any, record: any) => {
        const disabledStatuses = [
          "Pending",
          "InProgress",
          null,
          "proced 1 on 1",
          "Revert to manager",
          "Draft",
        ];
        const isDisabled = disabledStatuses.includes(record.manager_status);

        return isDisabled ? (
          <div
            className="btn btn-sm btn-primary custom_button d-flex align-items-center justify-content-center w-35"
            style={{ cursor: "not-allowed", opacity: 0.5 }}
            title="Cannot view details"
          >
            <i className="ti-eye" />
          </div>
        ) : (
          <Link
            to={`/pms-review-manager-r2/${record.employee_name}/${record.employee_id}`}
            className="btn btn-sm btn-primary custom_button d-flex align-items-center justify-content-center w-35"
            title="View Details"
          >
            <i className="ti-eye" />
          </Link>
        );
      },
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div>
            <h2 className="mb-1">Manager Dashboard</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.employeeDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">PMS</li>
                <li className="breadcrumb-item active">
                  Skip Manager Employee Profile
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex gap-2">
            <select
              value={finance_year}
              onChange={(e) => setFinance_year(e.target.value)}
              className="form-select"
            >
              {getFinancialYearListNew(finance_year).map((fy) => (
                <option key={fy} value={fy}>
                  {fy}
                </option>
              ))}
            </select>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h5>Employee List</h5>
          </div>
          <div className="card-body p-0">
            <Table
              dataSource={data || []}
              columns={columns}
              Selection={false}
              showSearchInput={true}
            />
          </div>
        </div>
      </div>
      <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
        <p className="mb-0">
          © {new Date().getFullYear()} WeConnect. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default R1ManagerAllEmployee;
